'use strict';


$(document).ready(function() {
    
    $('body').on('change', '.gift-selector .js-radio-button', function(e) {
        e.preventDefault();
        
        if ($(this).is(':checked')) {
            var selectedProductId = $(this).val();
            $('.product-detail.gift-selector').data('pid', selectedProductId);
        }
    }) 
        
});